import { Component, OnInit, Inject, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {CasoTareaModel, CasoTareaService} from 'src/app/services/casos_tareas.service';
import { VerTareaComponent } from 'src/app/components/casos/ver-tarea/ver-tarea.component';
import { TareaCasoMixedModel, TareaCasoModel, TareaCasoService } from 'src/app/services/tareacaso.service';
import { TareaModel, TareasService } from 'src/app/services/tareas.service';
// import { NoAprobarComentario } from '../no-aprobar-comentario/no-aprobar-comentario';
import {NotificacionService} from 'src/app/services/notificaciones.service';
import {DeteccionFraudesComentarioComponent} from '../comentario/comentario.component';
import {DeteccionFraudesAprobarCasoModalComponent} from '../aprobar-caso-modal/aprobar-caso-modal.component';

@Component ({
  templateUrl: './aprobar-caso.component.html',
  styleUrls: ['./aprobar-caso.component.scss']
})
export class DeteccionFraudesAprobarCasoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['caso', 'fecha_solicitud','comentario', 'opciones'];
  dataSource = new MatTableDataSource<any>();
  search:string = ''
  casos: CasoTareaModel[] = []
  casosOriginal: CasoTareaModel[] = []
  supervisor: boolean = false

  constructor(
    public _casos: CasoTareaService,
    public dialog: MatDialog,
    public  _tareacaso: TareaCasoService,
    public  _tareas: TareasService,
    public _notification: NotificacionService,
    private route: ActivatedRoute,
  ){
    this.supervisor =this.route.snapshot.routeConfig.path.includes('supervisor')
  }

  ngOnInit(){
    this.getCasos()
  }

  async getCasos(){
    this.casos = (await this._casos.getAprobacion().toPromise()).reverse()
    this.casos = this.casos.filter( (caso: CasoTareaModel) => {
      if(caso.tipo_caso == 'Detección y Análisis de Fraudes' || caso.tipo_caso == 'Gestión Administrativa de Fraudes'  ){
        if(this.supervisor && caso.aprobacionSupervisor !== true){
          return true
        }else if(!this.supervisor && caso.aprobacionSupervisor == true){
          return true
        }
      }
    })
    console.log('casos',this.casos)
    this.loadCasos()
  }

  loadCasos() {
    this.dataSource = new MatTableDataSource<any>(this.casos)
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
  }

  filter(){
    this.casosOriginal === null ? this.casosOriginal = this.casos : null
    this.casos = this.casosOriginal
    this.casos = this.casos.filter((historia:any)=>JSON.stringify(historia).toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
    this.loadCasos()
  }

  async aprobar(caso: CasoTareaModel){
    const dialogref = this.dialog.open(DeteccionFraudesAprobarCasoModalComponent,{data:caso,  disableClose: true })
    dialogref.afterClosed().subscribe((bool: string)=> bool == 'true' ? this.verificarAprobacion(caso) : null)
  }

  verificarAprobacion(caso: CasoTareaModel){
    if(this.supervisor) this.logicaSupervisorCasoAprobado(caso)
    else this.logicaGerenteCasoAprobado(caso)
  }

  logicaGerenteCasoAprobado(caso: CasoTareaModel){
    this._notification.aprobacion(caso.asignadoAID, caso.numero_caso).toPromise()
    caso.estado = 'En Ejecución'
    caso.solucion = 'Aprobado por el gerente'
    caso.aprobacion = false
    this._casos.put(caso._id,caso).toPromise()
    this.ngOnInit()
  }

  logicaSupervisorCasoAprobado(caso: CasoTareaModel){
    this.notificarGerentes(caso)
    this.cambiarModeloCaso(caso)
  }

  async notificarGerentes(caso: CasoTareaModel){
    await this._notification.notificacionDeteccionFraudesSolicitarRevisionGerente(caso.numero_caso).toPromise()
  }

  async cambiarModeloCaso(caso: CasoTareaModel){
    caso.aprobacionSupervisor = true
    console.log(caso)
    this.guardarHistorialAprobacion(caso,'')
    await this._casos.put(caso._id,caso).toPromise()
  }

  guardarHistorialAprobacion(caso: CasoTareaModel,comentario:string){
    caso.historial.push({
      usuario: `${sessionStorage.getItem("correo")}`,
      realizo:`No aprobo el caso "${caso.numero_caso}" por: ${comentario}`,
      date: new Date()
    })
  }

  async noAprobar(caso: CasoTareaModel) {
    console.log(caso)
    const dialogRef = this.dialog.open(DeteccionFraudesComentarioComponent,{width:'400px'})
    dialogRef.afterClosed().subscribe(async (comentario: string)=>{
      if(comentario){
        caso.aprobacion = false
        this.guardarHistorialAprobacion(caso,comentario)
        caso.estado = 'En Ejecución'
        caso.solucion = 'No Determinado'
        caso.aprobacionSupervisor = false
        await this._casos.put(caso._id,caso).toPromise()
        if(caso.tipo_caso == 'Gestión Administrativa de Fraudes' ){
          this._notification.rechazo(caso.asignadoAID, caso.numero_caso,comentario).toPromise()
        }else{
          this._notification.rechazo(caso.asignadoAID, caso.numero_caso,comentario).toPromise()
          this._notification.notificacionDeteccionFraudesSolicitarRevisionGerente(caso.numero_caso).toPromise()
        }
        
        this.ngOnInit()
      }
    })
  }

}
